import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { ReactComponent as DeleteIcon } from '../../../../assets/images/delete_t.svg';
import { api } from '../../../api';
import { ConfirmModal } from '../../../ui/ConfirmModal/ConfirmModal';
import { showToast } from '../../../ui/utils';

interface DeleteButtonProps {
  offerId: number;
  onSuccess: (id: number) => void;
}

export function DeleteButton({ offerId, onSuccess }: DeleteButtonProps) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirmDelete = () => {
    setIsDeleting(true);
    api
      .delete(`/v1/offers/${offerId}`)
      .then(() => {
        setShowConfirm(false);
        onSuccess(offerId);
      })
      .catch(() => {
        setIsDeleting(false);
        showToast({
          textMessage: 'There was an issue when deleting your offer, please try again later or contact support.',
          timeout: 20000,
        });
      });
  };

  return (
    <>
      <Button
        onClick={() => setShowConfirm(true)}
        variant="secondary"
        size="sm"
        className="mx-1"
        title="Delete"
      >
        <DeleteIcon className="btnImg" />
      </Button>
      <ConfirmModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        title="Delete Offer"
        confirmButtonTitle="Delete"
        onConfirm={handleConfirmDelete}
        onCancel={() => setShowConfirm(false)}
        isLoading={isDeleting}
      >
        Are you sure you want to delete this offer? This action cannot be undone.
      </ConfirmModal>
    </>
  );
}
